(ns frontend.test.select.sub
  (:require [frontend.test.select.model :as model]
            [re-frame.core :as rf]))

(rf/reg-sub
 ::state
 (fn [db]
   (get-in db model/root-path)))


(rf/reg-sub
 ::single-select-value
 :<-
 [::state]
 (fn [state]
   (get-in state model/single-select-value-path)))

(rf/reg-sub
 ::multi-select-value
 :<-
 [::state]
 (fn [state]
   (get-in state model/multi-select-value-path)))

(rf/reg-sub
 ::async-select-value
 :<-
 [::state]
 (fn [state]
   (get-in state model/async-select-value-path)))

(rf/reg-sub
 ::async-select-multi-value
 :<-
 [::state]
 (fn [state]
   (get-in state model/async-select-multi-value-path)))
